import { ConsumptionData } from '../../../../models/analysis/solar-calculator-request';

export class ParseConsumption {
  static parseConsumption(csvData: string[][]): ConsumptionData[] {
    const consumptionData: ConsumptionData[] = [];
    for (const row of csvData) {
      if((row.length === 1)) {
        continue;
      }
      consumptionData.push({ date: row[0], year: row[1], consumption: row[2], peakPower: row[3] });
    }
    return consumptionData;
  }
}
